const getUserEmailOptionLabel = ({ email = "", firstName = "", lastName = "", fullName = "" }) => {
  const normalizedEmail = email.toLowerCase();

  const firstLastName = [firstName, lastName].filter(Boolean).join(" ").trim();

  if (firstLastName) {
    return `${normalizedEmail} (${firstLastName})`;
  }
  if (fullName && fullName.toLowerCase() !== normalizedEmail) {
    return `${normalizedEmail} (${fullName})`;
  }

  return normalizedEmail;
};

export default getUserEmailOptionLabel;
